<template>
  <div class="email-data-cell">
    <div class="email-data-cell__data" :title='item[column.name]' :id="`${item.id}`">
      {{ item[column.name] }}
    </div>
    <div class="email-data-cell__copy" >
      <v-btn icon @click="copyEmail">
        <v-icon>content_copy</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  methods: {
    copyEmail() {
      const r = document.createRange();
      r.selectNode(document.getElementById(this.item.id));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(r);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
    },
  },
};

</script>
<style scoped lang="scss">
@import "src/assets/styles/variables";
.email-data-cell {
  display: flex;
  &__data{
    flex: fit-content;
    padding-top: 3px;
    max-height: 3.6em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__copy {
    flex: 1;
    padding-left: 5px;
    float: right;
    .v-btn--icon{
      color: $default-fill-color !important;
    }
    .v-icon {
      height: 20px;
      font-size: 20px;
      width: 20px;
    }
  }
}
</style>
